"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var React = _interopRequireWildcard(require("react"));

var _reactRange = require("react-range");

var _styledComponents = require("./styled-components.js");

var _overrides = require("../helpers/overrides.js");

function _interopRequireWildcard(obj) {
  if (obj && obj.__esModule) {
    return obj;
  } else {
    var newObj = {};

    if (obj != null) {
      for (var key in obj) {
        if (Object.prototype.hasOwnProperty.call(obj, key)) {
          var desc = Object.defineProperty && Object.getOwnPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : {};

          if (desc.get || desc.set) {
            Object.defineProperty(newObj, key, desc);
          } else {
            newObj[key] = obj[key];
          }
        }
      }
    }

    newObj.default = obj;
    return newObj;
  }
}

function _typeof(obj) {
  if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") {
    _typeof = function _typeof(obj) {
      return typeof obj;
    };
  } else {
    _typeof = function _typeof(obj) {
      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
  }

  return _typeof(obj);
}

function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};
    var ownKeys = Object.keys(source);

    if (typeof Object.getOwnPropertySymbols === 'function') {
      ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function (sym) {
        return Object.getOwnPropertyDescriptor(source, sym).enumerable;
      }));
    }

    ownKeys.forEach(function (key) {
      _defineProperty(target, key, source[key]);
    });
  }

  return target;
}

function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends.apply(this, arguments);
}

function _slicedToArray(arr, i) {
  return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _nonIterableRest();
}

function _nonIterableRest() {
  throw new TypeError("Invalid attempt to destructure non-iterable instance");
}

function _iterableToArrayLimit(arr, i) {
  var _arr = [];
  var _n = true;
  var _d = false;
  var _e = undefined;

  try {
    for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) {
      _arr.push(_s.value);

      if (i && _arr.length === i) break;
    }
  } catch (err) {
    _d = true;
    _e = err;
  } finally {
    try {
      if (!_n && _i["return"] != null) _i["return"]();
    } finally {
      if (_d) throw _e;
    }
  }

  return _arr;
}

function _arrayWithHoles(arr) {
  if (Array.isArray(arr)) return arr;
}

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _defineProperties(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor) descriptor.writable = true;
    Object.defineProperty(target, descriptor.key, descriptor);
  }
}

function _createClass(Constructor, protoProps, staticProps) {
  if (protoProps) _defineProperties(Constructor.prototype, protoProps);
  if (staticProps) _defineProperties(Constructor, staticProps);
  return Constructor;
}

function _possibleConstructorReturn(self, call) {
  if (call && (_typeof(call) === "object" || typeof call === "function")) {
    return call;
  }

  return _assertThisInitialized(self);
}

function _assertThisInitialized(self) {
  if (self === void 0) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return self;
}

function _getPrototypeOf(o) {
  _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
    return o.__proto__ || Object.getPrototypeOf(o);
  };
  return _getPrototypeOf(o);
}

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function");
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      writable: true,
      configurable: true
    }
  });
  if (superClass) _setPrototypeOf(subClass, superClass);
}

function _setPrototypeOf(o, p) {
  _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
    o.__proto__ = p;
    return o;
  };

  return _setPrototypeOf(o, p);
}

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
} // value.length should not be bigger than two
// because our design doesn't support more than
// two thumbs


var limitValue = function limitValue(value) {
  if (value.length > 2 || value.length === 0) {
    throw new Error('the value prop represents positions of thumbs, so its length can be only one or two');
  }

  return value;
};

var Slider =
/*#__PURE__*/
function (_React$Component) {
  _inherits(Slider, _React$Component);

  function Slider() {
    _classCallCheck(this, Slider);

    return _possibleConstructorReturn(this, _getPrototypeOf(Slider).apply(this, arguments));
  }

  _createClass(Slider, [{
    key: "getSharedProps",
    value: function getSharedProps() {
      var _this$props = this.props,
          disabled = _this$props.disabled,
          step = _this$props.step,
          min = _this$props.min,
          max = _this$props.max,
          value = _this$props.value;
      return {
        $disabled: disabled,
        $step: step,
        $min: min,
        $max: max,
        $value: limitValue(value)
      };
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props2 = this.props,
          _this$props2$override = _this$props2.overrides,
          overrides = _this$props2$override === void 0 ? {} : _this$props2$override,
          min = _this$props2.min,
          max = _this$props2.max,
          step = _this$props2.step,
          _onChange = _this$props2.onChange,
          disabled = _this$props2.disabled;
      var value = limitValue(this.props.value);

      var _getOverrides = (0, _overrides.getOverrides)(overrides.Root, _styledComponents.Root),
          _getOverrides2 = _slicedToArray(_getOverrides, 2),
          Root = _getOverrides2[0],
          rootProps = _getOverrides2[1];

      var _getOverrides3 = (0, _overrides.getOverrides)(overrides.Track, _styledComponents.Track),
          _getOverrides4 = _slicedToArray(_getOverrides3, 2),
          Track = _getOverrides4[0],
          trackProps = _getOverrides4[1];

      var _getOverrides5 = (0, _overrides.getOverrides)(overrides.InnerTrack, _styledComponents.InnerTrack),
          _getOverrides6 = _slicedToArray(_getOverrides5, 2),
          InnerTrack = _getOverrides6[0],
          innerTrackProps = _getOverrides6[1];

      var _getOverrides7 = (0, _overrides.getOverrides)(overrides.Thumb, _styledComponents.Thumb),
          _getOverrides8 = _slicedToArray(_getOverrides7, 2),
          Thumb = _getOverrides8[0],
          thumbProps = _getOverrides8[1];

      var _getOverrides9 = (0, _overrides.getOverrides)(overrides.InnerThumb, _styledComponents.InnerThumb),
          _getOverrides10 = _slicedToArray(_getOverrides9, 2),
          InnerThumb = _getOverrides10[0],
          innerThumbProps = _getOverrides10[1];

      var _getOverrides11 = (0, _overrides.getOverrides)(overrides.ThumbValue, _styledComponents.ThumbValue),
          _getOverrides12 = _slicedToArray(_getOverrides11, 2),
          ThumbValue = _getOverrides12[0],
          thumbValueProps = _getOverrides12[1];

      var _getOverrides13 = (0, _overrides.getOverrides)(overrides.Tick, _styledComponents.Tick),
          _getOverrides14 = _slicedToArray(_getOverrides13, 2),
          Tick = _getOverrides14[0],
          tickProps = _getOverrides14[1];

      var _getOverrides15 = (0, _overrides.getOverrides)(overrides.TickBar, _styledComponents.TickBar),
          _getOverrides16 = _slicedToArray(_getOverrides15, 2),
          TickBar = _getOverrides16[0],
          tickBarProps = _getOverrides16[1];

      var sharedProps = this.getSharedProps();
      return React.createElement(Root, _extends({
        "data-baseweb": "slider"
      }, sharedProps, rootProps), React.createElement(_reactRange.Range, {
        step: step,
        min: min,
        max: max,
        values: value,
        disabled: disabled,
        onChange: function onChange(value) {
          return _onChange({
            value: value
          });
        },
        renderTrack: function renderTrack(_ref) {
          var props = _ref.props,
              children = _ref.children,
              isDragged = _ref.isDragged;
          return React.createElement(Track, _extends({
            onMouseDown: props.onMouseDown,
            onTouchStart: props.onTouchStart,
            $isDragged: isDragged
          }, sharedProps, trackProps), React.createElement(InnerTrack, _extends({
            $isDragged: isDragged,
            ref: props.ref
          }, sharedProps, innerTrackProps), children));
        },
        renderThumb: function renderThumb(_ref2) {
          var props = _ref2.props,
              value = _ref2.value,
              index = _ref2.index,
              isDragged = _ref2.isDragged;
          return React.createElement(Thumb, _extends({}, props, {
            $thumbIndex: index,
            $isDragged: isDragged,
            style: _objectSpread({}, props.style)
          }, sharedProps, thumbProps), React.createElement(ThumbValue, _extends({
            $thumbIndex: index,
            $isDragged: isDragged
          }, sharedProps, thumbValueProps), value), React.createElement(InnerThumb, _extends({
            $thumbIndex: index,
            $isDragged: isDragged
          }, sharedProps, innerThumbProps)));
        }
      }), React.createElement(TickBar, _extends({}, sharedProps, tickBarProps), React.createElement(Tick, _extends({}, sharedProps, tickProps), min), React.createElement(Tick, _extends({}, sharedProps, tickProps), max)));
    }
  }]);

  return Slider;
}(React.Component);

_defineProperty(Slider, "defaultProps", {
  overrides: {},
  onChange: function onChange() {},
  min: 0,
  max: 100,
  step: 1
});

var _default = Slider;
exports.default = _default;